import React, { PureComponent } from 'react';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
// import EditDemographicsHOC from './editDemographicsHOC';
import EditOrganizationForm from '../forms/EditOrganizationForm';
import './EditDemographics.scss';


class EditDemographics extends PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onResetForm: PropTypes.func.isRequired,
    initialValues: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      cageCode: PropTypes.string,
      address1: PropTypes.string,
      address2: PropTypes.string,
      address3: PropTypes.string,
      zipCode: PropTypes.string,
      cntry: PropTypes.string,
      pointofContact: PropTypes.string,
      phoneNumber: PropTypes.string,
      organizationType: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      websiteUrl: PropTypes.string,
      naics: PropTypes.string,
      industryAssociations: PropTypes.string,
      associationValidations: PropTypes.string,
      industryType: PropTypes.string,
    }).isRequired,
    onCountryChange: PropTypes.func.isRequired,
    onStateProvChange: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    alertType: PropTypes.string.isRequired,
    alertMessage: PropTypes.string.isRequired,
  };

  render() {
    const { onSubmit, initialValues, alertType, alertMessage, onCountryChange, onStateProvChange, onFieldChange, onResetForm } = this.props;
    return (
      <div className="nf-add-organization">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Edit Demographics Page</title>
        </Helmet>
        <div className="edit-demographics-header">
          <h1>Company Demographics Management</h1>
          <p>Update your organization&apos;s demographic and contact information.</p>
        </div>
        <Container>
          <EditOrganizationForm
            initialValues={initialValues}
            onCountryChange={onCountryChange}
            onStateProvChange={onStateProvChange}
            onFieldChange={onFieldChange}
            onResetForm={onResetForm}
            onSubmit={onSubmit}
            alertType={alertType}
            alertMessage={alertMessage}
          />
        </Container>
      </div>
    );
  }
}

export default EditDemographics;



// WEBPACK FOOTER //
// ./src/components/EditDemographics/editDemographics.jsx